import React, { SyntheticEvent, useState } from 'react';
import classNames from 'classnames';

import './UploadBtnWithDropZone.sass';

type UploadBtnWithDropZoneProps = {
  label?: string;
  btnLabel?: string;
  isDisabled?: boolean;
  onChange(event: SyntheticEvent<HTMLInputElement>): void;
};

export const UploadBtnWithDropZone: React.FC<UploadBtnWithDropZoneProps> = ({
  label = 'Sem přetáhněte vaše soubory nebo',
  btnLabel = 'Vyberte soubor',
  isDisabled,
  onChange,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = () => {
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  return (
    <div
      className={classNames({
        'dmx-uploadBtnWithDropZone': true,
        'dmx-uploadBtnWithDropZone-isDragging': isDragging,
        'dmx-uploadBtnWithDropZone-isDisabled': isDisabled,
      })}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <input
        className='dmx-uploadBtnWithDropZone--input'
        multiple
        type='file'
        name='files'
        title=''
        disabled={isDisabled}
        onChange={onChange}
      />
      <p className='dmx-uploadBtnWithDropZone--label'>
        {label} <em className='dmx-uploadBtnWithDropZone--btn'>{btnLabel}</em>
      </p>
    </div>
  );
};
